module.exports = {
	"id": "MA",
	"name": "Morocco",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.011542,
			"5": 0.011542,
			"6": 0.023084,
			"7": 0.017313,
			"8": 0.017313,
			"9": null,
			"10": 0.011542,
			"11": 0.046168,
			"12": 0.028855,
			"13": 0.023084,
			"14": 0.005771,
			"15": null,
			"16": 0.023084,
			"17": 0.028855,
			"18": 0.011542,
			"19": 0.017313,
			"20": 0.005771,
			"21": 0.028855,
			"22": 0.05771,
			"23": 0.023084,
			"24": 0.017313,
			"25": 0.034626,
			"26": 0.063481,
			"27": 0.040397,
			"28": 0.046168,
			"29": 0.046168,
			"30": 0.05771,
			"31": 0.161588,
			"32": 0.051939,
			"33": 0.098107,
			"34": 0.046168,
			"35": 0.05771,
			"36": 0.040397,
			"37": 0.05771,
			"38": 0.098107,
			"39": 0.150046,
			"40": 0.144275,
			"41": 0.092336,
			"42": 0.092336,
			"43": 0.882963,
			"44": 0.138504,
			"45": 0.138504,
			"46": 0.219298,
			"47": 0.259695,
			"48": 0.398199,
			"49": 5.176587,
			"50": 0.323176,
			"51": 1.610109,
			"52": 0.767543,
			"53": 19.800301,
			"54": 6.169199,
			"55": 0.080794,
			"56": 0.017313,
			"57": null
		},
		"firefox": {
			"2": 0.005771,
			"3": 0.063481,
			"4": 0.011542,
			"5": 0.011542,
			"6": null,
			"7": 0.005771,
			"8": null,
			"9": 0.005771,
			"10": 0.017313,
			"11": 0.011542,
			"12": 0.034626,
			"13": 0.011542,
			"14": 0.017313,
			"15": 0.011542,
			"16": 0.046168,
			"17": 0.017313,
			"18": 0.017313,
			"19": 0.023084,
			"20": 0.023084,
			"21": 0.023084,
			"22": 0.017313,
			"23": 0.011542,
			"24": 0.017313,
			"25": 0.017313,
			"26": 0.034626,
			"27": 0.023084,
			"28": 0.017313,
			"29": 0.034626,
			"30": 0.046168,
			"31": 0.040397,
			"32": 0.051939,
			"33": 0.075023,
			"34": 0.046168,
			"35": 0.086565,
			"36": 0.063481,
			"37": 0.086565,
			"38": 0.11542,
			"39": 0.080794,
			"40": 0.086565,
			"41": 0.086565,
			"42": 0.098107,
			"43": 0.582871,
			"44": 0.138504,
			"45": 0.219298,
			"46": 0.271237,
			"47": 1.165742,
			"48": 0.767543,
			"49": 5.730603,
			"50": 0.092336,
			"51": 0.023084,
			"52": null,
			"3.5": 0.011542,
			"3.6": 0.075023
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.011542,
			"35": 0.017313,
			"36": 0.161588,
			"37": 0.040397,
			"38": 0.155817,
			"39": 0.040397,
			"40": 0.86565,
			"41": 0.144275,
			"42": 0.005771,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.034626
		},
		"safari": {
			"0": null,
			"4": 0.023084,
			"5": 0.034626,
			"6": 0.023084,
			"7": 0.028855,
			"8": 0.178901,
			"9": 0.126962,
			"10": 0.334718,
			"3.1": null,
			"3.2": null,
			"5.1": 0.046168,
			"6.1": 0.028855,
			"7.1": 0.005771,
			"9.1": 0.294321
		},
		"ios_saf": {
			"8": 0,
			"10": 2.35321842298,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0634165135304,
			"8.1-8.4": 0.117159321607,
			"9.0-9.2": 0.0558925203997,
			"9.3": 0.852719221482
		},
		"android": {
			"3": 0,
			"4": 0.139294736434,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0174118420543,
			"4.1": 0.502456013566,
			"4.2-4.3": 1.25614003391,
			"4.4": 2.88041615698,
			"4.4.3-4.4.4": 2.90529021705
		},
		"ie": {
			"6": 0.0373032680412,
			"7": 0.0435204793814,
			"8": 0.522245752577,
			"9": 0.360598257732,
			"10": 0.198950762887,
			"11": 1.24965947938,
			"5.5": null
		},
		"op_mob": {
			"0": 0.198025615125,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00550071153125
		},
		"edge": {
			"12": 0.075023,
			"13": 0.178901,
			"14": 0.184672
		},
		"ie_mob": {
			"10": 0.189292422535,
			"11": 0.770690577465
		},
		"bb": {
			"7": 0.0359465,
			"10": null
		},
		"samsung": {
			"0": 5.772585
		},
		"and_uc": {
			"0": 0.448274
		},
		"op_mini": {
			"0": 2.66796467334
		},
		"and_chr": {
			"0": 22.575402
		},
		"and_ff": {
			"0": 0.025374
		}
	},
	"total": 97.6297325
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MA.json
 ** module id = 582
 ** module chunks = 0
 **/